import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import Select from "react-select"
import moment from 'moment'
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import cogoToast from 'cogo-toast';

const TasksNotDone = props => {
  const [servicetypes, setServicetypes] = React.useState([]);
  const [groups, setGroups] = React.useState([]);

  const [servicetype, setServicetype] = useState(null);
  const [selectedGroups, setSelectedGroups] = useState([]);

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'weekly', value: 'weekly' });
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));

  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [errors, setErrors] = React.useState([]);

  const dateOptions = [
    { label: 'weekly', value: 'weekly' },
    { label: 'monthly', value: 'monthly' }
  ];


  const columns = [{
    dataField: 'slno',
    text: '#',
  },
  {
    dataField: 'asset.name',
    text: 'Asset name',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'activity.name',
    text: 'Activity name',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'task_date',
    text: 'Task date',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'groups',
    text: 'Assigned to',
    filter: textFilter(),
    formatter: (cell) => cell.map(c => c.name).join(', '),
    filterValue: (cell) => cell.map(c => c.name).join(', '),
    csvFormatter: (cell) => cell.map(c => c.name).join(', '),
  }, 
  {
    dataField: 'task_status',
    text: 'Status',
    sort: true,
    filter: textFilter(),
  }, 
  ];


  const init = () => {

    let initData = {
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    setLoading(true);
    post(url.INIT_TASKSNOTDONE, initData)
      .then((response) => {
        console.log('init RESP', response);
        if (response.status == 200) {
        setServicetypes(response.data.servicetypes);
        setGroups(response.data.groups);
        }
        else if (response.status == 400) {
          cogoToast.error('Could not fetch data');
        }
        else {
          console.log('err::', response);
          cogoToast.error('Could not fetch data');
        }
        setLoading(false);
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };

  const handleSubmit = () => {

    if(selectedGroups.length < 1) 
      {
      cogoToast.error('Please select at least one group');
      return;
    }

    let data = {
      'group_ids': selectedGroups.map(group => group.value),
      'start_date': startDate,
      'end_date': endDate,
      'block_id': props.filterBlock.id,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_TASKSNOTDONE, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data)
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };


React.useEffect(()=>{
    if(props.filterBlock) {
      // setSelectedServicetypes([]);
      init();
    }
  }, [props.filterBlock]);

  // console.log(open, closed)


  const displayedGroups = servicetype ? groups.filter(g => g.servicetype_id == servicetype.value) : groups;

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Tasks Not Done | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Tasks Not Done</h3>
            {/* <Link className="btn btn-primary" to={{pathname: "/activities/new", query: {id: 'new'}}}>Create New</Link> */}
          </div>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row">
                <div className="col">
                  <div className="">
                    <label className="label form-label">Filter by Service Type</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="All"
                        title="Service type"
                        options={servicetypes}
                        value={servicetype}
                        isClearable
                        onChange={e => { 
                          setSelectedGroups([]);
                          setServicetype(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">Group</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Group"
                        options={displayedGroups}
                        value={selectedGroups}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={e => { 
                            setSelectedGroups(e); 
                        }}
                        />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col">
                  <div className="">
                    <label className="label form-label">&nbsp;</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Set to..."
                        options={dateOptions}
                        value={selectedDateOption}
                        onChange={e => { 
                          if(e.value == 'weekly') {
                            setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'monthly') {
                            setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                            setSelectedDateOption(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">From</label>
                    <input 
                    // type="text"
                     className="form-control" id="dateFrom"
                      type="date"
                      value={startDate} onChange={e => { 
                        setStartDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">To</label>
                    <input 
                    // type="text" 
                    className="form-control" id="dateFrom"
                      type="date"
                      value={endDate} onChange={e => { 
                        setEndDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary" onClick={() => { handleSubmit(); }}>Generate</button>
              </div>
            </CardBody>
          </Card>



          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <BootstrapTable striped
                bordered={false}
                wrapperClasses="table-responsive" className="border border-danger" keyField='id' data={ data } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory() } />
            </CardBody>
          </Card>

        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(TasksNotDone)